<div class="grid grid-cols-2 gap-y-4">
    <div><sl-checkbox class="col-start-1" [checked]="hasPeriod" (checkedChange)="onCheckedChange($event)">{{title}}</sl-checkbox></div>
    <ws-time-period-selector [(ngModel)]="workDay" [disabled]="!hasPeriod"></ws-time-period-selector>
</div>